import * as amplitude from '@amplitude/analytics-browser'

export const trackMobileNav = (link: string) => {
	const eventData = {
		path: link,
		source: 'mobile-nav',
	}
	amplitude.track('Mobile-navigation-used', eventData)
}
